<mdc-card class="kasse__dagsinfo" *ngIf="kasse">
  <p *ngIf="kasse.aapen">
    Kassabeholdning ved oppstart {{ kasse.aapnet_ts | date : "d.M.yyyy" }}
  </p>
  <div>
    <mdc-text-field
      outlined
      class="w100"
      label="Kassebeholdning"
      type="number"
      [formControl]="kassasum"
    ></mdc-text-field>
  </div>
  <div>
    <mdc-select
      class="w100"
      [formControl]="avdeling"
      outlined
      placeholder="Avdeling"
    >
      <mdc-menu>
        <mdc-list>
          <mdc-list-item
            *ngFor="let avdeling of avdelinger"
            [value]="avdeling.id"
            >{{ avdeling.nr }} {{ avdeling.navn }}</mdc-list-item
          >
        </mdc-list>
      </mdc-menu>
    </mdc-select>
  </div>
  <button
    *ngIf="!kasse.aapen"
    mdc-button
    raised
    [disabled]="!kassasum.value && kassasum.value != 0"
    (click)="startSale()"
  >
    <span>Start dagens salg</span>
  </button>

  <p *ngIf="kasse.aapen" class="kasse__aapen">Dagens salg er startet</p>

  <ng-container *ngIf="kasse.aapen">
    <button mdc-button unelevated *ngIf="canEndDay()" (click)="confirmEndDay()">
      <span>Dagsoppgjør</span>
    </button>
    <button
      mdc-button
      class="button-no-bg"
      *ngIf="!canEndDay()"
      (click)="confirmEndDay()"
    >
      <span>Dagsoppgjør</span>
    </button>
  </ng-container>
</mdc-card>
